<template>
	<router-view />
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';

const SITE_URL = 'https://kmremodelingservices.com';
const DEFAULT_TITLE = 'K&M Remodeling Services | Charlotte, NC';
const DEFAULT_DESCRIPTION = 'Kitchen, bathroom and full home remodeling in Charlotte, NC and up to 50 miles around. Fixed price, one crew, zero surprises.';

export default {
	name: 'App',

	// Значения по умолчанию для всех страниц. Views переопределяют их своим useHead
	// (теги с тем же name/property и canonical заменяются, а не дублируются).
	setup() {
		const route = useRoute();

		const title = computed(() => route.meta.title || DEFAULT_TITLE);
		// Без query-параметров (utm и т.п.), чтобы у страницы был один канонический адрес
		const url = computed(() => SITE_URL + route.path);

		// Служебные страницы (meta.noindex в роутере): закрыты от индексации и без canonical
		const noindex = computed(() => Boolean(route.meta.noindex));

		useHead({
			title,
			link: computed(() => (noindex.value ? [] : [{ rel: 'canonical', href: url.value }])),
			meta: [
				{ name: 'robots', content: computed(() => (noindex.value ? 'noindex, follow' : 'index, follow')) },
				{ name: 'description', content: DEFAULT_DESCRIPTION },
				{ property: 'og:site_name', content: 'K&M Remodeling Services' },
				{ property: 'og:type', content: 'website' },
				{ property: 'og:title', content: title },
				{ property: 'og:description', content: DEFAULT_DESCRIPTION },
				{ property: 'og:url', content: url },
				{ property: 'og:image', content: `${SITE_URL}/monroe.jpg` },
				{ name: 'twitter:card', content: 'summary_large_image' },
			],
		});
	},
};
</script>

<style lang="scss">
	html {
		scroll-behavior: smooth;
	}
#app {
	min-height: 100%;
}

html,
body {
	height: 100%;
	margin-top: 0;
}
body{
	font-family: Manrope, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	margin: 0;
}
</style>
